
export interface OverViewDataType {
    collectionTime: string;
    costPrice: number;
    exchangeCount: number;
}

export interface DataType {
    activityId: number,
    activityName: string,
    activityCycleId: number,
    activityCycle: number,
    userCount: number,
    collectionUserCount: number,
    timeOutUserCount: number,
    verificationRate: number,
    costPrice: number
}

export interface productDataType {
    prouctId: number,
    productName: string,
    exchangeCount: number, 
}


export const overViewColumns = [
    {
        title: '核销成本',
        dataIndex: 'costPrice',
        key: 'costPrice',
    },
    {
        title: '兑换数量',
        dataIndex: 'exchangeCount',
        key: 'exchangeCount',
    }
];

export const columns = [
    {
        title: '权益包编号',
        dataIndex: 'activityId',
        key: 'activityId',
    },
    {
        title: '权益包名称',
        dataIndex: 'activityName',
        key: 'activityName',
    },
    {
        title: '期数',
        dataIndex: 'activityCycle',
        key: 'activityCycle',
    },
    {
        title: '本期内用户',
        dataIndex: 'userCount',
        key: 'userCount',
    },
    {
        title: '已领取用户',
        dataIndex: 'collectionUserCount',
        key: 'collectionUserCount',
    },
    {
        title: '超时未领取用户',
        dataIndex: 'timeOutUserCount',
        key: 'timeOutUserCount',
    },
    {
        title: '核销率',
        dataIndex: 'verificationRate',
        key: 'verificationRate',
    },
    {
        title: '核销成本',
        dataIndex: 'costPrice',
        key: 'costPrice',
    }
];

export const productColumns = [
   {
       title: '权益ID',
       dataIndex: 'prouctId',
       key: 'prouctId',
   },
   {
       title: '权益名称',
       dataIndex: 'productName',
       key: 'productName',
   },
   {
       title: '兑换数量',
       dataIndex: 'exchangeCount',
       key: 'exchangeCount',
   }
]